import React from 'react';
import { stats } from '../data/content';
export function Stats() {
  return <section aria-label="The system at a glance" className="bg-navy px-4 py-6 md:py-7" data-id="element-199" data-mp="2wxqf6edmwmjh">
      <ul className="mx-auto grid max-w-4xl grid-cols-6 gap-2 lg:grid-cols-5" data-id="element-200" data-mp="2wvdtpr8o3u1o">
        {stats.map(([value, label], index) => <li key={label} className={`rounded-xl border border-white/10 bg-white/5 px-2 py-3 text-center lg:col-span-1 ${index < 3 ? 'col-span-2' : 'col-span-3'}`} data-id="element-201" data-mp="2nwin4e1pohxu" data-mpi={index}>
            <p className={`whitespace-nowrap font-display font-black leading-none text-brand-light ${value.length > 3 ? 'pt-1 text-base md:text-lg' : 'text-2xl md:text-3xl'}`} data-id="element-202" data-mp="2dz4akpiwsdat">
              {value}
            </p>
            <p className="mt-1.5 text-[9px] font-bold uppercase leading-tight tracking-wider text-white/80 md:text-[10px]" data-id="element-203" data-mp="256sjd1fz0lts">
              {label}
            </p>
          </li>)}
      </ul>
    </section>;
}